module.exports = __webpack_public_path__ + "media/images/admin/icons/cloud-6320a388771887c1a0cb0b6cb6bfa0ab.svg";